import { ReactNode } from 'react';

import {
  deliveryDescription,
  paymentDescriptionB2c,
  saveMoneyDescriptionB2c,
  trustedPartnerDescriptionB2c,
} from '@/retention/Footer/modules/ReassuranceTitleList/translations';

import Delivery from '../assets/delivery-b2c.svg?url';
import Disponibility from '../assets/disponibility-b2c.svg?url';
import SaveMoney from '../assets/save-money-b2c.svg?url';
import TrustedPartner from '../assets/trusted-partener-b2c.svg?url';
import { ReassuranceItem } from '../ReassuranceItem.model';

export const items: ReassuranceItem[] = [
  {
    icon: SaveMoney,
    desc: saveMoneyDescriptionB2c,
  },
  {
    icon: Delivery,
    desc: deliveryDescription.format({
      link: (children: ReactNode) => '',
    }) as string,
  },
  {
    icon: Disponibility,
    desc: paymentDescriptionB2c,
  },
  {
    icon: TrustedPartner,
    desc: trustedPartnerDescriptionB2c,
  },
];
